import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const TIME_FORMAT_SINGLE_HOUR_KEY = 'libs.common.time-format.single-hour';
const TIME_FORMAT_PLURAL_HOUR_KEY = 'libs.common.time-format.plural-hour';
const TIME_FORMAT_SINGLE_MIN_KEY = 'libs.common.time-format.single-min';
const TIME_FORMAT_PLURAL_MIN_KEY = 'libs.common.time-format.plural-min';
const TIME_FORMAT_PLURAL_SEC_KEY = 'libs.common.time-format.plural-sec';

@Pipe({
  name: 'timeFormat',
  standalone: true,
})
export class TimeFormatPipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(value: number): string {
    if (!Number.isFinite(value) || value < 0) {
      return this.translate.instant(TIME_FORMAT_PLURAL_SEC_KEY, { seconds: 0 });
    }

    const totalSeconds = Math.floor(value);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const parts: string[] = [];

    if (hours > 0) {
      const key = hours === 1 ? TIME_FORMAT_SINGLE_HOUR_KEY : TIME_FORMAT_PLURAL_HOUR_KEY;
      parts.push(this.translate.instant(key, { hours }));
    }

    if (minutes > 0) {
      const key = minutes === 1 ? TIME_FORMAT_SINGLE_MIN_KEY : TIME_FORMAT_PLURAL_MIN_KEY;
      parts.push(this.translate.instant(key, { minutes }));
    }

    if (seconds > 0 || parts.length === 0) {
      parts.push(this.translate.instant(TIME_FORMAT_PLURAL_SEC_KEY, { seconds }));
    }

    return parts.join(' ');
  }
}
